var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:'fa fa-' + _vm.icon}),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }